"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameVendor = exports.TopPrizeType = exports.IJackpotStatus = exports.IJackpotGameResultDataType = exports.GamesList = exports.GameActivationMethodState = exports.GameState = exports.GET_NEXT_JACKPOT_RESULT = exports.GET_JACKPOT_RESULTS_FOR_GAME = exports.GET_JACKPOT_PAYOUT_FOR_DRAWS = exports.SEND_PLAYERS_DATA_FOR_JACKPOT = exports.GET_LATEST_JACKPOT_RESULTS = exports.GET_LATEST_RESULTS_FOR_DRAW = exports.GET_NEXT_JACKPOT_RESULTS_FOR_DRAW = exports.GET_JACKPOT_RESULTS_FOR_DRAW = exports.RESET_GAME = exports.GET_GAME_CONFIG = exports.GET_GAMES_BY_IDS = exports.ALL_RELATED_GAMES = exports.RELATED_GAMES = exports.REPLACE_FILTER = exports.CLEAR_FILTER = exports.FETCH_GAME_META = exports.UPDATE_FILTER = exports.RESET_JACKPOT = exports.RESET_STATE = exports.GAME_DRAWS = exports.GAME_PRIZES = exports.GAME_BY_ID = exports.GET_FEATURED_GAME = exports.PUBLISHED_GAMES = void 0;
var GamesList_1 = require("./GamesList");
Object.defineProperty(exports, "GamesList", { enumerable: true, get: function () { return GamesList_1.GamesList; } });
var IJackpotGameResultDataType;
(function (IJackpotGameResultDataType) {
    IJackpotGameResultDataType[IJackpotGameResultDataType["REGULAR"] = 0] = "REGULAR";
    IJackpotGameResultDataType[IJackpotGameResultDataType["HOT"] = 1] = "HOT";
    IJackpotGameResultDataType[IJackpotGameResultDataType["COLD"] = 2] = "COLD";
    IJackpotGameResultDataType[IJackpotGameResultDataType["SPECIAL"] = 3] = "SPECIAL";
})(IJackpotGameResultDataType || (IJackpotGameResultDataType = {}));
exports.IJackpotGameResultDataType = IJackpotGameResultDataType;
var IJackpotStatus;
(function (IJackpotStatus) {
    IJackpotStatus[IJackpotStatus["OPEN"] = 0] = "OPEN";
    IJackpotStatus[IJackpotStatus["PAYABLE"] = 1] = "PAYABLE";
})(IJackpotStatus || (IJackpotStatus = {}));
exports.IJackpotStatus = IJackpotStatus;
var GameActivationMethodState;
(function (GameActivationMethodState) {
    GameActivationMethodState[GameActivationMethodState["DATA_SET_LEVEL"] = 0] = "DATA_SET_LEVEL";
    GameActivationMethodState[GameActivationMethodState["BOOK_LEVEL"] = 1] = "BOOK_LEVEL";
    GameActivationMethodState[GameActivationMethodState["TICKET_LEVEL"] = 2] = "TICKET_LEVEL";
})(GameActivationMethodState || (GameActivationMethodState = {}));
exports.GameActivationMethodState = GameActivationMethodState;
var GameState;
(function (GameState) {
    GameState[GameState["DELETED"] = 0] = "DELETED";
    GameState[GameState["PUBLISHED"] = 1] = "PUBLISHED";
    GameState[GameState["DRAFT"] = 2] = "DRAFT";
})(GameState || (GameState = {}));
exports.GameState = GameState;
var TopPrizeType;
(function (TopPrizeType) {
    TopPrizeType["PROGRESSIVE"] = "PROGRESSIVE";
    TopPrizeType["STATIC"] = "STATIC";
})(TopPrizeType || (TopPrizeType = {}));
exports.TopPrizeType = TopPrizeType;
var GameVendor;
(function (GameVendor) {
    GameVendor["PBL"] = "PBL";
    GameVendor["SGI"] = "SGI";
    GameVendor["IGT"] = "IGT";
    GameVendor["NEOGAME"] = "NEOGAME";
    GameVendor["NGL"] = "NGL";
})(GameVendor || (GameVendor = {}));
exports.GameVendor = GameVendor;
var PUBLISHED_GAMES = 'games/PUBLISHED_GAMES';
exports.PUBLISHED_GAMES = PUBLISHED_GAMES;
var GET_FEATURED_GAME = 'games/GET_FEATURED_GAME';
exports.GET_FEATURED_GAME = GET_FEATURED_GAME;
var GAME_BY_ID = 'games/GAME_BY_ID';
exports.GAME_BY_ID = GAME_BY_ID;
var GAME_PRIZES = 'games/GAME_PRIZES';
exports.GAME_PRIZES = GAME_PRIZES;
var GAME_DRAWS = 'games/GAME_DRAWS';
exports.GAME_DRAWS = GAME_DRAWS;
var RESET_STATE = 'games/RESET_STATE';
exports.RESET_STATE = RESET_STATE;
var UPDATE_FILTER = 'games/UPDATE_FILTER';
exports.UPDATE_FILTER = UPDATE_FILTER;
var FETCH_GAME_META = 'games/FETCH_GAME_META';
exports.FETCH_GAME_META = FETCH_GAME_META;
var CLEAR_FILTER = 'games/CLEAR_FILTER';
exports.CLEAR_FILTER = CLEAR_FILTER;
var REPLACE_FILTER = 'games/REPLACE_FILTER';
exports.REPLACE_FILTER = REPLACE_FILTER;
var RELATED_GAMES = 'games/RELATED_GAMES';
exports.RELATED_GAMES = RELATED_GAMES;
var ALL_RELATED_GAMES = 'games/ALL_RELATED_GAMES';
exports.ALL_RELATED_GAMES = ALL_RELATED_GAMES;
var GET_GAMES_BY_IDS = 'games/GET_GAMES_BY_IDS';
exports.GET_GAMES_BY_IDS = GET_GAMES_BY_IDS;
var GET_GAME_CONFIG = 'games/GET_GAME_CONFIG';
exports.GET_GAME_CONFIG = GET_GAME_CONFIG;
var RESET_GAME = 'games/RESET_GAME';
exports.RESET_GAME = RESET_GAME;
var RESET_JACKPOT = 'games/RESET_JACKPOT';
exports.RESET_JACKPOT = RESET_JACKPOT;
var GET_LATEST_JACKPOT_RESULTS = 'games/GET_LATEST_JACKPOT_RESULTS';
exports.GET_LATEST_JACKPOT_RESULTS = GET_LATEST_JACKPOT_RESULTS;
var GET_JACKPOT_RESULTS_FOR_DRAW = 'games/GET_JACKPOT_RESULTS_FOR_DRAW';
exports.GET_JACKPOT_RESULTS_FOR_DRAW = GET_JACKPOT_RESULTS_FOR_DRAW;
var GET_NEXT_JACKPOT_RESULTS_FOR_DRAW = 'games/GET_NEXT_JACKPOT_RESULTS_FOR_DRAW';
exports.GET_NEXT_JACKPOT_RESULTS_FOR_DRAW = GET_NEXT_JACKPOT_RESULTS_FOR_DRAW;
var GET_LATEST_RESULTS_FOR_DRAW = 'games/GET_LATEST_RESULTS_FOR_DRAW';
exports.GET_LATEST_RESULTS_FOR_DRAW = GET_LATEST_RESULTS_FOR_DRAW;
var SEND_PLAYERS_DATA_FOR_JACKPOT = 'games/SEND_PLAYERS_DATA_FOR_JACKPOT';
exports.SEND_PLAYERS_DATA_FOR_JACKPOT = SEND_PLAYERS_DATA_FOR_JACKPOT;
var GET_JACKPOT_PAYOUT_FOR_DRAWS = 'games/GET_JACKPOT_PAYOUT_FOR_DRAWS';
exports.GET_JACKPOT_PAYOUT_FOR_DRAWS = GET_JACKPOT_PAYOUT_FOR_DRAWS;
var GET_NEXT_JACKPOT_RESULT = 'games/GET_NEXT_JACKPOT_RESULT';
exports.GET_NEXT_JACKPOT_RESULT = GET_NEXT_JACKPOT_RESULT;
var GET_JACKPOT_RESULTS_FOR_GAME = 'games/GET_JACKPOT_RESULTS_FOR_GAME';
exports.GET_JACKPOT_RESULTS_FOR_GAME = GET_JACKPOT_RESULTS_FOR_GAME;
//# sourceMappingURL=types.js.map